<template>
  <div>
    <el-select v-model="_id" class="mr-3" placeholder="支付方式" clearable @clear="onClear" @change="onSelect">
      <el-option v-for="item in payment_type" :key="item.payment_code" :label="item.name" :value="item.eng_name" />
    </el-select>
  </div>
</template>
<script>
import { getMvmSelect } from '@/api/mvms';
import { getPayments } from '@/api/payments';
export default {
  computed: {
    _id: {
      get() {
        return this.id;
      },
      set(val) {
        // console.log(`payment.vue: set val ${val}`);
        this.$emit('update:id', val);
      },
    },
  },
  props: {
    id: {
      default: null,
    },
  },
  data() {
    return {
      payment_type: [],
      uid: null,
      condition: {
        payment_code: null,
      },
    };
  },
  watch: {
    async companyId() {
      this.condition.company_id = this.companyId;
      this._id = null;
      this.onSelect();
      this.mvms = await getMvmSelect(this.condition);
    },
    async clientId() {
      this.condition.client_id = this.clientId;
      this._id = null;
      this.onSelect();
      this.mvms = await getMvmSelect(this.condition);
    },
  },

  async created() {
    this.payment_type = await getPayments();
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    },
    onClear() {
      this._id = null;
      this.onSelect();
    },
  },
};
</script>
